import { observable, action } from 'mobx'

class DashboardStore{

    @observable mainServiceTiles = [];
    @observable hotDealTiles = [];
    @observable facilityAndServicesTiles = [];

    @action
    getMainServiceTiles(){

        const newData = [
            {
                icon: 'https://gw.alipayobjects.com/zos/rmsportal/nywPmnTAvTmLusPxHPSu.png',
                text: 'Concierge',
                link: '/concierge'
            },
            {
                icon: 'https://gw.alipayobjects.com/zos/rmsportal/nywPmnTAvTmLusPxHPSu.png',
                text: 'Amenities',
                link: '/amenities'
            },
            {
                icon: 'https://gw.alipayobjects.com/zos/rmsportal/nywPmnTAvTmLusPxHPSu.png',
                text: 'F&B',
                link: '/foodAndBeverage'
            },
            {
                icon: 'https://gw.alipayobjects.com/zos/rmsportal/nywPmnTAvTmLusPxHPSu.png',
                text: 'Housekeeping',
                link: '/housekeeping'
            }
        ];

        // const data = Array.from(new Array(4)).map((_val, i) => ({
        //     icon: 'https://gw.alipayobjects.com/zos/rmsportal/nywPmnTAvTmLusPxHPSu.png',
        //     text: `name${i}`,
        //   }));

        this.mainServiceTiles = newData;
    }

    @action
    getHotDealTiles(){
        this.hotDealTiles = ['AiyWuByWklrrUDlFignR', 'TekJlZRVCjLFexlOCuWn', 'IJOtIlfsYdTyaDTRVrLI'];
    }

    @action
    getFacilityAndServicesTiles(){
        this.facilityAndServicesTiles = ['AiyWuByWklrrUDlFignR', 'TekJlZRVCjLFexlOCuWn', 'AiyWuByWklrrUDlFignR', 'IJOtIlfsYdTyaDTRVrLI', 'TekJlZRVCjLFexlOCuWn'];
    }
}

export default new DashboardStore();